import styled from 'styled-components';

const DealRoomCard = styled.div`
  color: ${(props) => props.theme.color.slate200};
`;

export { DealRoomCard };
